import { SIDEBAR_WIDTH } from "components/apiDocs/ApiSidebar/style";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const StyledBody = styled.div`
  width: calc(100% - ${SIDEBAR_WIDTH});
  height: 100%;
  padding: 80px 60px;

  &&.guidance {
    width: 55%;
    padding: 80px 0 80px 120px;
  }
`;

export const StyledTagHeader = styled.h2`
  && {
    font-size: ${fonts.mediumBigger};
    margin-top: 66px;
    margin-bottom: 8px;
  }
`;

export const StyledTagDescription = styled.p`
  font-weight: ${fonts.semibold};

  &&& {
    margin-bottom: 8px;
  }
`;

export const StyledHorizontalRule = styled.hr`
  background-color: ${colours.mediumGrey};
  height: 1px;
  padding: 0;
  margin: 0;
`;

export const StyledEndpointUrl = styled.p`
  &&& {
    font-size: ${fonts.mediumSmaller};
    padding: 24px 0 0 0;
    overflow-wrap: break-word;
    word-wrap: break-word;

    a {
      color: ${colours.elexonBlue};
    }
  }
`;

export const StyledTabButton = styled.button`
  flex: 1 0 2em;
  height: 50px;
  border: 1px solid ${colours.mediumGrey};
  margin-right: -1px;
  background-color: white;
  align-items: center;

  :hover {
    background-color: ${colours.elexonLightBlue};
    cursor: pointer;
  }

  &&.active {
    background-color: ${colours.elexonBlue};

    span {
      color: ${colours.white};
    }
  }

  :disabled {
    background-color: ${colours.lightGrey};
    cursor: auto;

    span {
      color: ${colours.mediumGrey};
    }
  }
`;

export const StyledTabText = styled.span`
  && {
    font-size: ${fonts.large};
    font-weight: ${fonts.heavy};
    margin-bottom: 0;
    color: ${colours.darkGrey};
  }
`;

export const StyledTabsContainer = styled.nav`
  display: flex;
`;

interface StyledTabContentProps {
  singleColumn?: boolean;
}

export const StyledEndpointsContainer = styled.ul<StyledTabContentProps>`
  && {
    column-count: ${(props: StyledTabContentProps): number =>
      props.singleColumn === true ? 1 : 2};
    margin: 0;
    list-style-type: none;

    @media screen and (max-width: 1200px) {
      column-count: 1;
    }
  }
`;

export const StyledEndpointSection = styled.li`
  break-inside: avoid-column;
`;

export const StyledFilteredResultsSection = styled.ul`
  && {
    display: block;
    width: 85%;
    margin: 0;
    list-style-type: none;
  }
`;

export const TopBottomMargin = styled.div`
  margin: 3em 0;
`;
